// extracted by mini-css-extract-plugin
export var icon = "_9f-3";
export var subtitle = "_9f-2";
export var title = "_9f-1";
export var value = "_9f-0";